import { graphql } from 'react-relay';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type {
	preloadCreateSpaceQuery$data,
	preloadCreateSpaceQuery$variables,
} from './__generated__/preloadCreateSpaceQuery.graphql.ts';

type PreloadCreateSpaceOptions = {
	isLicensed: boolean;
};

/**
 * see next/packages/create-space/src/useCanCreateSpace.tsx for the query usage
 */
const PreloadCreateSpaceQuery = graphql`
	query preloadCreateSpaceQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				operations {
					operation
				}
			}
		}
	}
`;

export const preloadCreateSpace = ({
	isLicensed,
}: PreloadCreateSpaceOptions): Promise<{ data: unknown }> => {
	if (!isLicensed) {
		return Promise.resolve({ data: null });
	}

	return query<preloadCreateSpaceQuery$data, preloadCreateSpaceQuery$variables>({
		query: PreloadCreateSpaceQuery,
	});
};
